import {Button} from '@/components/ui/button/Button'
import {AlertCircleIcon, CheckCircleIcon} from '@/components/ui/icon/Icon'
import {useTranslation} from '@/translations/i18n'
import {
    StyledBulkSiarExportDialogFooter,
    StyledBulkSiarExportResultBody,
    StyledBulkSiarExportResultFileName,
    StyledBulkSiarExportResultIcon,
    StyledBulkSiarExportResultSubtitle,
    StyledBulkSiarExportResultTitle,
    StyledBulkSiarExportSkippedBox,
    StyledBulkSiarExportSkippedHeader,
    StyledBulkSiarExportSkippedList
} from '@/features/projects/siar-bulk-export/components/bulk-siar-export-dialog/style'

export type SkippedProject = {
    projectId: string
    projectCode: number | null
}

type BulkSiarExportResultStepProps = {
    pendingCount: number
    fileName: string
    skippedProjects: SkippedProject[]
    onClose: () => void
    onGoToGroup?: () => void
}

const formatPriCode = (code: number): string => `PRI-${String(code).padStart(4, '0')}`

export const BulkSiarExportResultStep = ({
    pendingCount,
    fileName,
    skippedProjects,
    onClose,
    onGoToGroup
}: BulkSiarExportResultStepProps) => {
    const {t} = useTranslation()

    return (
        <>
            <StyledBulkSiarExportResultBody>
                <StyledBulkSiarExportResultIcon>
                    <CheckCircleIcon size={48} />
                </StyledBulkSiarExportResultIcon>
                <StyledBulkSiarExportResultTitle>
                    {t('projects:bulk_siar_export_success_title')}
                </StyledBulkSiarExportResultTitle>
                <StyledBulkSiarExportResultFileName>{fileName}</StyledBulkSiarExportResultFileName>
                <StyledBulkSiarExportResultSubtitle>
                    {t('projects:bulk_siar_export_success_subtitle', {count: pendingCount})}
                </StyledBulkSiarExportResultSubtitle>
                {skippedProjects.length > 0 && (
                    <StyledBulkSiarExportSkippedBox>
                        <StyledBulkSiarExportSkippedHeader>
                            <AlertCircleIcon size={16} />
                            <strong>{t('projects:bulk_siar_export_skipped_result_title')}</strong>
                        </StyledBulkSiarExportSkippedHeader>
                        <span>{t('projects:bulk_siar_export_skipped_result_description')}</span>
                        <StyledBulkSiarExportSkippedList>
                            {skippedProjects.map(project => (
                                <li key={project.projectId}>
                                    {project.projectCode !== null
                                        ? formatPriCode(project.projectCode)
                                        : project.projectId}
                                </li>
                            ))}
                        </StyledBulkSiarExportSkippedList>
                    </StyledBulkSiarExportSkippedBox>
                )}
            </StyledBulkSiarExportResultBody>
            <StyledBulkSiarExportDialogFooter>
                {onGoToGroup && (
                    <Button variant="secondary" onClick={onGoToGroup}>
                        {t('projects:bulk_siar_export_go_to_group')}
                    </Button>
                )}
                <Button variant="primaryNeutral" onClick={onClose}>
                    {t('commons:close')}
                </Button>
            </StyledBulkSiarExportDialogFooter>
        </>
    )
}
